import { SessionBackend } from "../../decoders/ihr-user";

export abstract class BaseStoreSession<T> {
  abstract currentSession: SessionBackend<T> | null;

  abstract storeSession<X>(session: SessionBackend<X>): void;
}
